<template>
  <div class="about bg-color-dark text-color-light">
    <vue-headful :title="doctitle" />
    <b-container class="pb-5">
      <b-row>
        <b-col xl="1"></b-col>
        <b-col>
          <h1 class="mt-5 text-color-light big-headline">About Øredev</h1>
          <p class="p-margin-bottom">
            ØREDEV was founded in 2005 by Jayway, called <a href="https://jayway.com?utm_source=oredev" target="_blank"
              >Devoteam</a
            > today, a design driven software
            studio with offices in Malmö, Stockholm, Copenhagen, and Palo Alto.
            Øredev inherited its vision and philosophy.
          </p>
          <h2 class="text-color-light headline-margin-top">Our Vision</h2>
          <p class="p-margin-bottom">
            Øredev has its origins and focuses on the software development
            process, from programming to project management. We work to organize
            an event based on the concept of quality — for learning and
            networking — Sharing Knowledge.
          </p>
          <h2 class="text-color-light headline-margin-top">Our Philosophy</h2>
          <p class="p-margin-bottom">
            Having fun! Each year is unique with new topics, new speakers, and
            new challenges. As such, we have to constantly evolve and reinvent
            ourselves. This is both what makes our work fun and why we believe
            it's so important that others have fun as a result of our work.
          </p>

          <h2 class="text-color-light headline-margin-top">Our Social Commitment </h2>
          <p class="p-margin-bottom">
            <p>Every year, our commitment is to support organizations that share our core values, with a shared mission to make the world a better place. We are grateful for the opportunity to contribute in our own small way. Currently, we are proud to collaborate with the following companies:</p>

<ul>
  <li><a href="https://www.pinkprogramming.se/">Pink Programming</a>
    <p>Pink Programming is a non-profit organization based in Sweden that is dedicated to promoting gender equality in the tech industry. Their mission is to create an inspiring environment where women and non-binary individuals can thrive in the field of programming. They achieve this by organizing coding events and diversity and inclusion (D&I) courses. The organization is membershio driven and aims to address the gender gap in the technology sector.</p>
  </li>
  
  <li><a href="https://www.redi-school.org/redi-school-malmo">Redi School of Digital Integration</a>
    <p>ReDI School is a non-profit tech school for women with a migrant and refugee background, offering a free program that includes IT and tech courses at several levels. Our focus is to create digital empowerment by supporting women in gaining access to digital skills and a social and professional network in Sweden. We also work for more diversity and inclusion in the Swedish labor market, especially in the tech sector. We believe that newcomers are a great opportunity for society, and we are here to give them a helping hand to make use of their potential.</p>
  </li>
  
  <li><a href="https://www.foocoding.org/">FooCoding</a>
    <p>FooCoding is a course in software development run by the Foo Café Foundation in Malmö and Stockholm. The six-month program is aimed at disadvantaged groups in Swedish society and provides them with the skills they need to find a job as full-stack web developers in Sweden. The ambition is to integrate people struggling to find work in Sweden into the world of tech. The program is completely free of charge and includes support for students with computers, free commuting, and free food during classes.</p>
  </li>

  <li><a href="https://www.mossy.earth/">Mossy Earth</a>
    <p>Mossy Earth works with one mission in mind, to restore wild ecosystems, support wildlife and biodiversity and help fight climate change.
</p>
  </li>
</ul>

          </p>

          <h2 class="text-color-light headline-margin-top">Ourselves</h2>
          <p class="p-margin-bottom">
            We try to keep things nice and equal; for each being from the
            sapiens species, there's a much fluffier being from the canis genus.
            <br />
            Between the humans behind Øredev, we boast several nationalities, a
            huge variety of hair lengths — or lack thereof — and backgrounds.
            That's what reminds us every single day that diversity and equality
            are king and queen. Respectively. Meet with the two main organisers
            and head to the program committee page to meet with the rest of the
            team.
          </p>
          <h2 class="text-color-light headline-margin-top">Our committee</h2>
          <p class="p-margin-bottom">
            Øredev is over 100 sessions, ~100 top-notch speakers from all over,
            6 keynotes revolving around a theme that changes every year, and
            some 1,300 visitors during 3 days at the beginning of November.
          </p>
          <p class="p-margin-bottom">
            All this is coordinated by 2 people and the program largely composed
            by our <router-link to="/committee">committee</router-link>. We are
            immensely thankful to them for making Øredev what it is.
          </p>

          <div class="team">
            <div class="member">
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1683542543/2023_web/Emy_kvadrat_1.png"
              />
              <div class="member-description">
                <h2>Emy W. Kristoffersson</h2>
                <p>
                  Emy is a creative enthusiast who loves to paint, read and
                  write, or why not play with one of her hobby designs in Figma
                  or take on a new course in some technical field. When she
                  isn’t keeping herself busy with some creative or social
                  project, she loves experiencing the thrill of live music and
                  is always up for a good concert. She’s an extrovert who has a
                  passion for bringing people together to make an impact and to
                  feel inspired – in other words, a perfect Øredev-match!
                </p>
                <p></p>
                <p></p>
              </div>
            </div>

            <div class="member">
              <img
                src="https://res.cloudinary.com/oredev/image/upload/v1681908849/2023_web/maisa_1.png"
              />
              <div class="member-description">
                <h2>Maisa Dabus</h2>
                <p>
                  Maisa's passion is to work on bringing people together to
                  experience the best in life, feel inspired, share a feeling of
                  belonging and joy regardless of where they come from and their
                  daily challenges and for the past 12 years she's done so by
                  working with events - a variety of it and for all walks of
                  life. She has more playlists she can account for, a nerdy-soul
                  disguised by her endless curiosity and she’s convinced she's yet to write her Oscar-winning screenplay. 
                  For now, you can catch her leading Øredev, a task she takes wholeheartedly
                  as she strive for keeping its legacy alive!
                </p>

                <p></p>

                <p></p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col xl="1"></b-col>
      </b-row>
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-1"
        src="https://res.cloudinary.com/oredev/image/upload/v1679424057/2023_web/shapes%20lp/white-shape-1.png"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1683012353/2023_web/white-shape-2.png"
      />
      <img
        src="https://res.cloudinary.com/oredev/image/upload/v1679424058/2023_web/shapes%20lp/white-shape-5.png"
        class="d-none d-xl-block position-absolute"
        id="white-shape-3"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1680087567/2023_web/shapes%20info/white-shape-3.png"
        alt="rectangle"
      />
      <img
        id="white-shape-5"
        class="d-none d-xl-block position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088000/2023_web/shapes%20info/white-shape-4.png"
        alt="rectangle"
      />

      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1680088576/2023_web/shapes%20info/white-shape-6.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-7"
        src="https://res.cloudinary.com/oredev/image/upload/v1680090042/2023_web/shapes%20info/white-shape-5.png"
        alt="rectangle"
      />
      <img
        class="d-none d-xl-block position-absolute"
        id="white-shape-8"
        src="https://res.cloudinary.com/oredev/image/upload/v1680089901/2023_web/shapes%20info/white-shape-7.png"
        alt="rectangle"
      />

      <img
        class="rectangle-long-1 position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-long-2 d-none d-md-block position-absolute"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-2"
        src="https://res.cloudinary.com/oredev/image/upload/v1679666601/2023_web/shapes%20info/Blue-shape-1.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <!-- here -->
      <img
        class="rectangle-orange position-absolute"
        id="orange-3"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-5"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
      <img
        class="rectangle-orange position-absolute"
        id="orange-4"
        src="https://res.cloudinary.com/oredev/image/upload/v1678533180/2023_web/temp/%C3%98redev_2023.png"
      />
      <img
        class="rectangle-green-short position-absolute"
        id="green-6"
        src="https://res.cloudinary.com/oredev/image/upload/v1679903087/2023_web/shapes%20info/Blue-shape-2.png"
        alt="rectangle"
      />
    </b-container>
  </div>
</template>

<script>
export default {
  name: "about",
  data() {
    return {
      doctitle: "About Øredev - " + this.$store.state.conferencename,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 20px;
  font-weight: 700;
}

.big-headline {
  font-size: 32px;
}

.team {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin: 2rem 0 0;
}
.member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 280px;
}
.member img {
  border-radius: 200px;
  height: auto;
  max-width: 100%;
  margin-bottom: 2rem;
  z-index: 99;
}
.member h2 {
  font-size: 1.5rem !important;
  text-decoration: none;
}

@media screen and (max-width: 991px) {
  .member {
    width: 200px;
  }
}

@media screen and (max-width: 767px) {
  .member {
    width: 160px;
  }
  .member h2 {
    font-size: 0.9em !important;
  }
}

@media screen and (max-width: 576px) {
  .team {
    flex-direction: column;
  }
  .member {
    width: auto;
  }
  .member h2 {
    font-size: 1.3rem !important;
  }
  .member img {
    max-width: 300px;
  }
}

.rectangle-long-1 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  bottom: -196%;
  left: 0;
}
.rectangle-long-2 {
  width: 100%;
  height: 30px;
  mix-blend-mode: color;
  position: absolute;
  top: 100%;
  left: 0;
}

.rectangle-green-short,
.rectangle-orange {
  mix-blend-mode: color !important;
}

#green-2 {
  bottom: 50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#green-3 {
  bottom: 29%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-4 {
  bottom: 17.5%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#green-5 {
  bottom: -80%;
  left: 0;
  max-width: 80%;
  z-index: 0;
}
#green-6 {
  bottom: -130%;
  max-width: 58%;
  z-index: 1;
  right: 0;
}
#orange-3 {
  bottom: -50%;
  right: 0;
  z-index: 0;
  height: 16px;
  width: 51%;
}
#orange-4 {
  bottom: -110%;
  left: 0;
  width: 60%;
  height: 16px;
  z-index: 0;
}

#white-shape-1 {
  right: 30px;
  bottom: 75%;
}
#white-shape-2 {
  right: 35px;
  bottom: 71%;
}
#white-shape-2-mobile {
  right: 35px;
  bottom: 64%;
}
#white-shape-3 {
  right: 0;
  bottom: 37%;
  width: 16%;
}
#white-shape-4 {
  left: 3%;
  bottom: 37%;
}
#white-shape-5 {
  left: 3%;
  bottom: 7%;
  width: 17%;
}
#white-shape-6 {
  right: 3%;
  bottom: -22%;
}
#white-shape-7 {
  left: 3%;
  bottom: 5%;
}
#white-shape-8 {
  right: 3%;
  bottom: 13%;
}
</style>



// WEBPACK FOOTER //
// src/components/About.vue